module.exports = __webpack_public_path__ + "img/css.ea657d95.svg";